import React from 'react'
import { Box, Divider, FormControl } from '@chakra-ui/react'
import BlueprintList from '../../../components/ui/BlueprintList/BlueprintList'
import DropzoneUploader from '../../../components/features/DropzoneUploader/DropzoneUploader'
import CustomFormLabel from '../../../components/ui/CustomFormLabel'

const SetupDataSource = () => {
  return (
    <div>
      <Box
        borderBottom="1px solid"
        borderColor="brand.lightGray"
        pb="12px">
        <FormControl mb="16px">
          <CustomFormLabel>
            a) Select the file to be used for this client's report:
          </CustomFormLabel>
          <DropzoneUploader />
        </FormControl>
        <Divider mb="16px" />
        <FormControl>
          <CustomFormLabel>
            b) Select the blueprint to be used for this client's report:
          </CustomFormLabel>
          <BlueprintList />
        </FormControl>
      </Box>
    </div>
  )
}

SetupDataSource.propTypes = {}

export default SetupDataSource
